export default __webpack_public_path__ + "static/media/membership-1.c494e988.png";